module.exports = __webpack_public_path__ + "img/photo_2023-11-22 14.30.28.4f32b5b7.jpg";